export default __webpack_public_path__ + "static/media/laravel-negative.b5dc4ffd.svg";